import ProfileTemplate from "../../../templates/users/profile";

const ProfileScreen = () => {
  return <ProfileTemplate />;
};

export default ProfileScreen;
